import { Chip, FlexRowCenter, GridRow, SingleSelect } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useRuleStore } from "csi/middleware/attributeRule/RuleStore";
import { ComponentItem } from "designSystem/types/component-item-types";

interface CustomViewConditionOperatorProps {
	/** the index of this rule */
	index: number;

    /** the number of filters in the store or filter group */
    count: number;

    /** call back function when changes are made*/
    onChange: Function;

    /** available option for dropdown */
    options: ComponentItem[];

    /** selected value of dropdown */
    value: ComponentItem;

}

const CustomViewConditionOperator: FunctionComponent<CustomViewConditionOperatorProps> = observer((props) => {
	const {
		index,
		count,
		onChange,
		options,
		value,
	} = props;

	if (count === 0) {
		return null;
	}

	return (
		<FlexRowCenter
			my={2}
			width={50}
		>
			{count > 1 && index === 1 && options && (
				<SingleSelect
					fullWidth
					inline
					onChange={(event, newValueItem, reason) => onChange(newValueItem)}
					options={options}
					required
					value={value}
				/>
			)}
			{count > 2 && index !== 1 &&
				<Chip res={value.id} />
			}
		</FlexRowCenter>
	);
});

export default CustomViewConditionOperator;